import { attr, html, TNode, Value } from '@tempots/dom'

export type StepCardOptions = {
  color: Value<'blue' | 'rose' | 'green'>
  number: TNode
  title: TNode
  description: TNode
}

export function StepCard({
  color,
  number,
  title,
  description,
}: StepCardOptions) {
  return html.div(
    attr.class(
      'flex flex-col items-center gap-2 p-4 sm:p-5 md:p-6 rounded-lg bg-white w-full sm:w-56 md:w-64'
    ),
    html.div(
      attr.class(
        Value.map(color, v => {
          const colors = {
            blue: 'bg-blue-50 text-blue-700',
            rose: 'bg-rose-50 text-rose-700',
            green: 'bg-green-50 text-green-700',
          }
          return colors[v]
        })
      ),
      attr.class(
        'flex items-center justify-center p-2 rounded-full w-12 h-12 sm:w-14 sm:h-14'
      ),
      attr.class(Value.map(color, v => `bu-text--${v}`)),
      number
    ),
    html.div(attr.class('font-bold text-sm sm:text-base text-center'), title),
    html.div(
      attr.class('text-sm sm:text-base leading-tight text-center'),
      description
    )
  )
}
